import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreLabel } from "@slhuicore/label";

import { style } from "./assets/label.generated-style";

/**
 * Label content
 *
 * @CustomElement slh-label
 *
 * @cssprop --slh-default-font-family - Label font family.
 * @cssprop --slh-base-xs-font-size - Label font size.
 * @cssprop --slh-base-xxs-line-height - Label font line height.
 * @cssprop --slh-base-semi-bold-font-weight - Label font weight.
 * @cssprop --slh-color-neutral-shade-60 - Label font color.
 */
@customElement("slh-label")
export default class SlhLabel extends SlhCoreLabel(LitElement) {
  static styles = style;
}
